/*
 * ATLAS pixels — the same events Releasit fires, to the same pixels,
 * with the Purchase fired once on the thank-you page (/pages/merci).
 */
(() => {
  'use strict';
  if (window.AtlasPixels) return;

  const CFG = window.ATLAS_COD || {};
  const P = CFG.pixels || {};
  const on = CFG.firePixels === true;
  const KEY = 'atlas_purchase';

  const safe = (fn) => {
    try { fn(); } catch (e) { /* a broken pixel must never block an order */ }
  };
  const round = (v) => Math.round(Number(v) * 100) / 100;

  function loadScript(src) {
    const s = document.createElement('script');
    s.async = true;
    s.src = src;
    document.head.appendChild(s);
  }

  // Load the pixels Releasit loads today — only those not already on the page
  function ensurePixels() {
    if (!on) return;

    (P.facebook || []).forEach((id) => safe(() => {
      let created = false;
      if (typeof window.fbq !== 'function') {
        const f = function () {
          if (f.callMethod) f.callMethod.apply(f, arguments);
          else f.queue.push(arguments);
        };
        window.fbq = f;
        if (!window._fbq) window._fbq = f;
        f.push = f;
        f.loaded = true;
        f.version = '2.0';
        f.queue = [];
        loadScript('https://connect.facebook.net/en_US/fbevents.js');
        created = true;
      }
      const loaded = window.fbq.getState ? window.fbq.getState().pixels.map((p) => String(p.id)) : [];
      if (!loaded.includes(String(id))) window.fbq('init', String(id));
      if (created) window.fbq('track', 'PageView');
    }));

    (P.tiktok || []).forEach((id) => safe(() => {
      if (!window.ttq) {
        const t = [];
        window.ttq = t;
        window.TiktokAnalyticsObject = 'ttq';
        t.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
        t.setAndDefer = (o, m) => {
          o[m] = function () { o.push([m].concat(Array.prototype.slice.call(arguments, 0))); };
        };
        t.methods.forEach((m) => t.setAndDefer(t, m));
        t.load = (e) => {
          t._i = t._i || {};
          t._i[e] = [];
          t._i[e]._u = 'https://analytics.tiktok.com/i18n/pixel/events.js';
          t._t = t._t || {};
          t._t[e] = Date.now();
          t._o = t._o || {};
          t._o[e] = {};
          loadScript('https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + e + '&lib=ttq');
        };
        t.load(String(id));
        t.page();
      } else if (!(window.ttq._i && window.ttq._i[id])) {
        window.ttq.load(String(id));
      }
    }));

    const google = (P.google || []).filter((g) => g && g.id);
    if (google.length) safe(() => {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        loadScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(google[0].id));
      }
      const configured = window.dataLayer.filter((x) => x && x[0] === 'config').map((x) => x[1]);
      google.forEach((g) => { if (!configured.includes(g.id)) window.gtag('config', g.id); });
    });

    (P.pinterest || []).forEach((id) => safe(() => {
      if (typeof window.pintrk !== 'function') {
        const p = function () { p.queue.push(Array.prototype.slice.call(arguments)); };
        p.queue = [];
        p.version = '3.0';
        window.pintrk = p;
        loadScript('https://s.pinimg.com/ct/core.js');
      }
      window.__atlasPinterest = window.__atlasPinterest || {};
      if (!window.__atlasPinterest[id]) {
        window.pintrk('load', String(id));
        window.__atlasPinterest[id] = true;
      }
    }));
  }

  const fb = (name, data, opts) => safe(() => {
    if (typeof window.fbq !== 'function') return;
    if (opts) window.fbq('track', name, data, opts);
    else window.fbq('track', name, data);
  });
  const tt = (name, data, opts) => safe(() => {
    if (!window.ttq) return;
    if (opts) window.ttq.track(name, data, opts);
    else if (data) window.ttq.track(name, data);
    else window.ttq.track(name);
  });
  const g4 = (name, data) => safe(() => {
    if (typeof window.gtag !== 'function') return;
    if (data) window.gtag('event', name, data);
    else window.gtag('event', name);
  });
  const pin = (name, data) => safe(() => {
    if (typeof window.pintrk === 'function') window.pintrk('track', name, data);
  });

  const lineValue = (i) => round((i.price * i.quantity) / 100);
  const totals = (items) => ({
    value: round(items.reduce((s, i) => s + i.price * i.quantity, 0) / 100),
    count: items.reduce((s, i) => s + i.quantity, 0),
  });

  // Form opened — Releasit: FB InitiateCheckout + AddToCart, TikTok InitiateCheckout, GA4 begin_checkout
  function initiateCheckout(items, currency) {
    if (!on || !items || !items.length) return;
    const { value, count } = totals(items);
    fb('InitiateCheckout', { currency, value, num_items: count });
    if (CFG.fbSendAtc !== false) fb('AddToCart', { currency, value, num_items: count });
    tt('InitiateCheckout', {
      contents: items.map((i) => ({ content_id: String(i.productId || i.variantId), content_type: 'product', content_name: i.title, price: lineValue(i), quantity: i.quantity })),
      value,
      currency,
    });
    g4('begin_checkout');
    if (CFG.pinterestSendAtc !== false) pin('addtocart', { value, currency, order_quantity: count });
  }

  // First time the buyer types in the form — Releasit: FB AddPaymentInfo
  let infoSent = false;
  function infoFilled() {
    if (!on || infoSent) return;
    infoSent = true;
    if (CFG.sendFill !== false) fb('AddPaymentInfo');
  }

  // WhatsApp button — Releasit: FB Lead, TikTok Contact, GA4 generate_lead
  function whatsappClick() {
    if (!on) return;
    fb('Lead');
    tt('Contact');
    g4('generate_lead');
  }

  function buildPurchase(order, items, currency, phone) {
    const { value, count } = totals(items || []);
    return {
      orderId: String(order.id || '').split('/').pop(),
      orderName: order.name || '',
      value,
      count,
      currency,
      phone: phone || '',
      items: (items || []).map((i) => ({ productId: i.productId, variantId: i.variantId, title: i.title, price: i.price, quantity: i.quantity })),
    };
  }

  function store(data) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(data));
      return true;
    } catch (e) {
      return false;
    }
  }

  // Order placed — Releasit: FB Purchase, TikTok Purchase, Pinterest checkout, GA4 purchase, Google Ads conversion
  function purchase(d) {
    if (!on || !d || !d.orderId) return;
    const firedKey = 'atlas_purchase_fired_' + d.orderId;
    try {
      if (localStorage.getItem(firedKey)) return;
      localStorage.setItem(firedKey, '1');
    } catch (e) { /* storage blocked: still fire for this page view */ }
    const items = d.items || [];
    fb('Purchase', { currency: d.currency, value: d.value, num_items: d.count }, { eventID: d.orderId });
    if (d.phone) safe(() => { if (window.ttq && window.ttq.identify) window.ttq.identify({ phone_number: d.phone }); });
    tt('Purchase', {
      contents: items.map((i) => ({ content_id: String(i.productId || i.variantId), content_type: 'product', content_name: i.title, price: lineValue(i), quantity: i.quantity, description: i.title })),
      description: items.map((i) => i.title).join(', '),
      value: d.value,
      currency: d.currency,
    }, { event_id: d.orderId + '-Purchase' });
    pin('checkout', { value: d.value, currency: d.currency, order_quantity: d.count });
    g4('purchase', {
      transaction_id: d.orderName,
      value: d.value,
      currency: d.currency,
      items: items.map((i) => ({ item_id: String(i.productId || i.variantId), item_name: i.title, currency: d.currency, price: lineValue(i), quantity: i.quantity })),
    });
    (P.google || []).forEach((g) => {
      if (g && g.id && g.purchaseLabel) g4('conversion', { send_to: g.id + '/' + g.purchaseLabel, value: d.value, currency: d.currency, transaction_id: d.orderName });
    });
  }

  function onThankYouPage() {
    const path = CFG.thankYouPath || '/pages/merci';
    if (location.pathname.replace(/[/]$/, '') !== path) return;
    const ref = new URLSearchParams(location.search).get('commande');
    const label = document.getElementById('atlas-merci-commande');
    if (label && ref) label.textContent = 'Commande n° ' + ref.replace(/[^0-9A-Za-z-]/g, '');
    let d = null;
    try { d = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { d = null; }
    if (!d) return;
    purchase(d);
    try { sessionStorage.removeItem(KEY); } catch (e) { /* nothing to clean */ }
  }

  window.AtlasPixels = { initiateCheckout, infoFilled, whatsappClick, buildPurchase, store, purchase };

  ensurePixels();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onThankYouPage);
  else onThankYouPage();
})();
